module.exports = __webpack_public_path__ + "static/img/10003.5fb20986.png";